import { createStore, createHook } from 'react-sweet-state';

type State = {
	scrollElement: HTMLElement | null;
};

const actions = {
	setScrollElement:
		(scrollElement: HTMLElement | null) =>
		({ setState }: { setState: (arg1: State) => void }) =>
			setState({ scrollElement }),
} as const;
type Actions = typeof actions;

const Store = createStore<State, Actions>({
	initialState: { scrollElement: null },
	actions,
	name: 'JWMBoardScrollElementStore',
});

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useScrollElementStore = createHook(Store);
